import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import List, { ListItem, ListItemText } from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import Icon from 'material-ui/Icon'


import { ModalHeader, ModalContents, ModalFooter } from '../../common/modal'

class MoveTests extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      message: false
    }
    this.onSelect = this.onSelect.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

  }


  componentWillMount() {
    const {
      getJobs,
      job
    } = this.props
    getJobs(job.id).then((res => {
      this.setState({
        message: !parseInt(res, 10) > 0
      })
    }))
  }


  onSelect(e, job) {
    this.setState({
      selected: job
    })
  }

  handleClose() {
    this.setState({
      selected: null
    })
    this.props.onClose()
  }

  handleSubmit() {
    const {
      job,
      selectedTests,
      selectAll
    } = this.props
    const {
      selected
    } = this.state

    let destinationjobid = selected.id

    let testids = selectedTests.map((item) => item.id)
    this.props.onSubmit({ jobid: job.id, testids, destinationjobid })

  }

  render() {
    const {
      translate,
      classes,
      job,
      jobs,
      selectedtotal,
      filteredJobs
    } = this.props
    const {
      selected,
      message
    } = this.state

    return (
      <Modal open={true} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" className={classes.title} color="inherit">
                {translate("test_move_title")}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <Typography type="subheading" className={classes.subTitle} color="inherit">
                {translate("test_move_text", { number: selectedtotal, name: job.name })}
              </Typography>
              <List className={classes.list}>
                {
                  filteredJobs && filteredJobs.map((item, index) => {
                    return (item.id !== job.id) ? (
                      <ListItem className={selected && (item.id === selected.id) ? `${classes.listItem} ${classes.selectedListItem}` : `${classes.listItem}`} key={`move-tests-job-${index}`} button onClick={(e) => this.onSelect(e, item)}>
                        <Avatar>
                          <Icon>folder</Icon>
                        </Avatar>
                        <ListItemText primary={item.name} secondary={item.customer_name} />
                      </ListItem>
                    ) : (null)
                  })
                }

              </List>
              {message && (
                <Typography type="subheading" color="inherit">
                  {translate("test_move_no_jobs_text")}
                </Typography>
              )}
            </ModalContents>
            <ModalFooter className={classes.footer}>

              {selected && (<Button raised
                color="accent"
                className={classes.submit}
                onClick={this.handleSubmit}
                type="submit"
              >
                {translate('test_move_confirm')}
              </Button>)

              }
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}
export default withStyles(styles)(MoveTests)



// WEBPACK FOOTER //
// ./src/components/job/move/index.js